import { render, staticRenderFns } from "./CartControls.vue?vue&type=template&id=47f42552&scoped=true&"
import script from "./CartControls.vue?vue&type=script&lang=js&"
export * from "./CartControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f42552",
  null
  
)

export default component.exports